import { render, staticRenderFns } from "./WaterCompanyManage.vue?vue&type=template&id=c056e6ba&"
import script from "./WaterCompanyManage.vue?vue&type=script&lang=js&"
export * from "./WaterCompanyManage.vue?vue&type=script&lang=js&"
import style0 from "./WaterCompanyManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports